/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PriceRequest model module.
 * @module model/PriceRequest
 * @version v0
 */
export default class PriceRequest {
  /**
   * Constructs a new <code>PriceRequest</code>.
   * @alias module:model/PriceRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PriceRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PriceRequest} obj Optional instance to populate.
   * @return {module:model/PriceRequest} The populated <code>PriceRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PriceRequest();
      if (data.hasOwnProperty('paymentFrequency'))
        obj.paymentFrequency = ApiClient.convertToType(data['paymentFrequency'], 'String');
      if (data.hasOwnProperty('currency'))
        obj.currency = ApiClient.convertToType(data['currency'], 'String');
      if (data.hasOwnProperty('planId'))
        obj.planId = ApiClient.convertToType(data['planId'], 'String');
      if (data.hasOwnProperty('numberOfEditors'))
        obj.numberOfEditors = ApiClient.convertToType(data['numberOfEditors'], 'Number');
      if (data.hasOwnProperty('numberOfSources'))
        obj.numberOfSources = ApiClient.convertToType(data['numberOfSources'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} paymentFrequency
 */
PriceRequest.prototype.paymentFrequency = undefined;

/**
 * @member {String} currency
 */
PriceRequest.prototype.currency = undefined;

/**
 * @member {String} planId
 */
PriceRequest.prototype.planId = undefined;

/**
 * @member {Number} numberOfEditors
 */
PriceRequest.prototype.numberOfEditors = undefined;

/**
 * @member {Number} numberOfSources
 */
PriceRequest.prototype.numberOfSources = undefined;

